import { render, staticRenderFns } from "./CusPaymentsTable.vue?vue&type=template&id=15fe4040&scoped=true"
import script from "./CusPaymentsTable.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./CusPaymentsTable.vue?vue&type=style&index=0&id=15fe4040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe4040",
  null
  
)

export default component.exports